//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQListBtn from "@/components/Generics/AQButtonsList/AQButtonsList.vue";
import draggable from "@/assets/images/drag-icon.svg";
import conditionValueInput from "./condition-value-input.vue";
import conditionLogicOperator from "./condition-logic-operator.vue";

export default {
    components: {
        conditionValueInput,
        conditionLogicOperator,
        AQListBtn
    },
    props: {
        value: {
            type: Object,
            required: true,
            default() {
                return {
                    type: "condition",
                    logicalCondition: "==",
                    val1: {
                        type: "MOD",
                        value: "",
                        fieldType: ""
                    },
                    val2: {
                        type: "MOD",
                        value: "",
                        fieldType: ""
                    },
                    logicOperatorAfter: null
                };
            }
        },
        isReadOnly: {
            required: false,
            type: Boolean,
            default: false
        },
        itemIndex: {
            type: Number,
            default: 0,
            required: true
        },
        fromRepeatable: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showLabelLogic: false,
            isFocus: false,
            hideListBtns: ["edit", "more", "copy", "download"],
            draggableIcon: `img:${draggable}`,
            comparisonOperators: [
                {
                    value: "==",
                    label: `<div class="operator-symbol">
                                ==
                            </div>
                            <span class="symbol-label">&nbsp;
                                ${this.$t(
        "diagrams.components.setConditions.equals"
    )}
                            </span>`
                },
                {
                    value: "!=",
                    label: `<div class="operator-symbol">
                                !=
                            </div>
                            <span class="symbol-label">&nbsp;
                                ${this.$t(
        "diagrams.components.setConditions.notEquals"
    )}
                        </span>`
                },
                {
                    value: ">",
                    label: `<div class="operator-symbol">
                                >
                            </div>
                            <span class="symbol-label">&nbsp;
                                ${this.$t(
        "diagrams.components.setConditions.greater"
    )}
                            </span>`
                },
                {
                    value: ">=",
                    label: `<div class="operator-symbol">
                                >=
                            </div>
                            <span class="symbol-label">&nbsp;
                                ${this.$t(
        "diagrams.components.setConditions.greaterOrEqual"
    )}
                            </span>`
                },
                {
                    value: "<",
                    label: `<div class="operator-symbol">
                                <
                            </div>
                            <span class="symbol-label">&nbsp;
                                ${this.$t(
        "diagrams.components.setConditions.less"
    )}
                            </span>`
                },
                {
                    value: "<=",
                    label: `<div class="operator-symbol">
                                <=
                            </div>
                            <span class="symbol-label">&nbsp;
                                ${this.$t(
        "diagrams.components.setConditions.lessOrEqual"
    )}
                            </span>`
                }
            ],
            validationFunctions: [
                {
                    value: "isEmpty",
                    label: `<div class="operator-symbol empty-logical-div">
                                ${this.$t(
        "diagrams.components.setConditions.is"
    )}
                            </div>
                            <span class="symbol-label empty-logical-span">&nbsp;
                                ${this.$t(
        "diagrams.components.setConditions.is"
    )}
                            </span>
                            <span class="label-empty empty-logical-span">
                                [${this.$t(
        "diagrams.components.empty"
    ).toLowerCase()}]
                            </span>`
                },
                {
                    value: "isNotEmpty",
                    label: `<div class="operator-symbol empty-logical-div">
                                ${this.$t(
        "diagrams.components.setConditions.not"
    )}
                            </div>
                            <span class="symbol-label empty-logical-span">&nbsp;
                                ${this.$t(
        "diagrams.components.setConditions.isNot"
    )}
                            </span>
                            <span class="label-empty empty-logical-span">
                                [${this.$t(
        "diagrams.components.empty"
    ).toLowerCase()}]
                            </span>`
                }
            ]
        };
    },
    computed: {
        computedComparisonOperators() {
            return this.value.val1.type === "MOD"
                || this.value.val1.type === "VAR"
                ? [...this.comparisonOperators, ...this.validationFunctions]
                : [...this.comparisonOperators];
        },
        filterType1() {
            if (this.value.val2.type !== "TXT") {
                return this.value.val2.fieldType;
            }
        },
        filterType2() {
            if (this.value.val1.type !== "TXT") {
                return this.value.val1.fieldType;
            }
        },
        displayedComparisonOperator() {
            const match = this.computedComparisonOperators.find(
                (item) => item.value === this.value.logicalCondition
            );
            return (match.value === "isNotEmpty" || match.value === "isEmpty") ? match.label : match.value;
        }
    },
    watch: {
        value: {
            handler(newVal) {
                const isFunction = this.validationFunctions.find(
                    (item) => item.value === newVal.logicalCondition
                );
                const canHaveFunction = newVal.val1.type === "MOD" || newVal.val1.type === "VAR";
                if (isFunction) {
                    newVal.val2.type = "";
                    newVal.val2.fieldType = "";
                    newVal.val2.value = "empty";
                } else if (
                    newVal.val2.value === "empty"
                    && newVal.val2.type === ""
                ) {
                    newVal.val2.type = "MOD";
                    newVal.val2.value = "";
                    newVal.val2.fieldType = "";
                }
                if (!canHaveFunction && isFunction) {
                    newVal.logicalCondition = this.comparisonOperators[0].value;
                }
            },
            deep: true
        }
    },
    mounted() {
        this.showLabelLogic = !!(this.value.logicalCondition === "isEmpty" || this.value.logicalCondition === "isNotEmpty");
    },
    methods: {
        setLogicalCondition(val) {
            const newValue = val.value || val;
            this.showLabelLogic = !!(newValue === "isEmpty" || newValue === "isNotEmpty");
            this.value.logicalCondition = newValue;
        },
        emitShowDataModel(condition, field) {
            this.$emit("showDataModel", { condition, field });
        },
        emitShowVariables(condition, field) {
            this.$emit("showVariables", { condition, field });
        },
        emitHideSpecialIdentificators() {
            this.$emit("hideSpecialIdentificators");
        }
    }
};
